import React from 'react'
// import {Link} from 'react-router-dom'
import './style.css'

export default function FormInput(props) {
    return (
        <div className="form">
        <p className={props.cLable}>{props.lable}</p>
              <input className={props.cName} type={props.type} disabled={props.disabled} placeholder={props.place} value={props.value} onChange={props.onChange} onClick={props.onClickInput} />
               <img className={props.cImg} onClick={props.onClick} src={props.src} alt={props.eye} />
        </div>
    )
}
